// extracted by css-extract-rspack-plugin
export default {"container":"container-gVmSgf","editor-container":"editor-container-vQ5g_2","editorContainer":"editor-container-vQ5g_2"};